export const formatVat = (value) => {
    if (value != null) {
        const vat = value.toFixed(2);
        if (vat % 1 !== 0) {
            const formattedVAT = vat.toLocaleString('nb-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
            return formattedVAT.replace('.', ',');
        } else {
            const formattedVAT = vat.replace(/\.0+$/, '');
            return formattedVAT.replace('.', ',') + ',-';
        }
    } else {
        return null;
    }
};
export const removeDecimals = (value) => {

    if (value !== undefined && value !== null) {
        let floatValue;
        const trimmedValue = value.replace(/\s/g, '').replace(',', '.');
        const adjustedStringValue = trimmedValue.replace('−', '-');
        floatValue = parseFloat(trimmedValue.charAt(0) === "-" ? adjustedStringValue.substring(1) : adjustedStringValue);
        const roundedValue = floatValue.toFixed(2);
        if (roundedValue % 1 !== 0) {
            const stringValue = parseFloat(roundedValue).toLocaleString('nb-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

            return stringValue.endsWith('.00') ? stringValue.slice(0, -3).replace('.', ',') : stringValue.replace('.', ',');
        }
        else {
            const stringValue = floatValue.toLocaleString('nb-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).replace(/\,00+$/, '');
            return stringValue.replace('.', ',') + ',-';
        }

    } else {
        return value;
    }
};
